import React from "react";
import Popup from "./BasePopup";

const Qualification = ({ isOpen, title, onClose, qualification }) => {
  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose}>
      <>
        {qualification.winnerCount && 
      <div className="qualification-popup">
        <div className="qualification-popup-rank">
              {`Rank 1-${qualification.winnerCount}`}
        </div> 
        <div className="qualification-popup-round">
            Qualified for next round
        </div>
      </div>}
        
      </>
    </Popup>
  );
};

export default Qualification;